var a = Object.defineProperty, c = Object.defineProperties;
var l = Object.getOwnPropertyDescriptors;
var r = Object.getOwnPropertySymbols;
var f = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
var i = (m, e, o) => e in m ? a(m, e, { enumerable: !0, configurable: !0, writable: !0, value: o }) : m[e] = o, t = (m, e) => {
  for (var o in e || (e = {}))
    f.call(e, o) && i(m, o, e[o]);
  if (r)
    for (var o of r(e))
      n.call(e, o) && i(m, o, e[o]);
  return m;
}, p = (m, e) => c(m, l(e));
import s, { forwardRef as d } from "react";
import w from "../lib/IconBase.mjs";
import P from "../defs/PencilSimple.mjs";
const R = d((m, e) => /* @__PURE__ */ s.createElement(w, p(t({ ref: e }, m), { weights: P })));
R.displayName = "PencilSimple";
export {
  R as PencilSimple
};
